import React, {PureComponent, useEffect, useRef, useState} from 'react';
// #FOLD_BLOCK
import {
  ViewState,
  GroupingState,
  IntegratedGrouping,
  // Appointment,
  EditingState,
  IntegratedEditing,
} from '@devexpress/dx-react-scheduler';
// #FOLD_BLOCK
import {
  Scheduler,
  WeekView,
  DayView,
  Appointments,
  Toolbar,
  DateNavigator,
  ViewSwitcher,
  AllDayPanel,
  AppointmentTooltip,
  AppointmentForm,
  GroupingPanel,
  Resources,
  DragDropProvider,
} from '@devexpress/dx-react-scheduler-material-ui';
import { connectProps } from '@devexpress/dx-react-core';
import { styled, alpha } from '@mui/material/styles';
// import PriorityHigh from '@mui/icons-material/PriorityHigh';
// import LowPriority from '@mui/icons-material/LowPriority';
// import Lens from '@mui/icons-material/Lens';
// import Event from '@mui/icons-material/Event';
// import AccessTime from '@mui/icons-material/AccessTime';
import Paper from '@mui/material/Paper';
// import MenuItem from '@mui/material/MenuItem';
// import Select from '@mui/material/Select';
// import Grid from '@mui/material/Grid';
// import FormControl from '@mui/material/FormControl';
// import classNames from 'clsx';

// import { priorities } from './demo-data/tasks';
// import { data as tasks } from './demo-data/grouping';

import { green, deepOrange, lightBlue } from '@mui/material/colors';

import { createAgendaShiftByUserId, getAgendaUser, shiftsByComId, updateAgendaShift, usersByComId } from './queries';
import { AgendaUser, CreateAgendaShiftByUserIdMutation, CreateAgendaShiftByUserIdMutationVariables, GetAgendaUserQuery, 
        GetAgendaUserQueryVariables, 
        ModelSortDirection, 
        ShiftsByComIdQuery, 
        ShiftsByComIdQueryVariables, 
        UpdateAgendaShiftMutation, 
        UpdateAgendaShiftMutationVariables, 
        UsersByComIdQuery,
        UsersByComIdQueryVariables} from '../../graphql/API';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { useAuthContext } from '../../contexts/AuthContext';
import { Modal, Spinner, Button as Btn } from 'react-bootstrap';
import { Button, IconButton, TextField, Fab, Container, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Close, CalendarToday, Create, LocationOn, Add as AddIcon, Notes } from '@mui/icons-material';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import useScheduleItems from '../services/ScheduleItems/ScheduleItems'
import UserImage from '../../components/UserImage';
import AppointmentFormCustom from '../services/ScheduleItems/AppointmenFormCustom';
import { v4 as uuidv4 } from 'uuid';
import { format } from 'date-fns';
import i18n from '../../contexts/I18n';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
// import * as localization from 'devextreme/localization';
import { ViewSwitcher as ViewSwitcherBase } from "@devexpress/dx-react-scheduler";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { Pagination } from '@aws-amplify/ui-react';
import CustomModal from '../../components/Modals/CustomModal';
import { enUS, fr } from 'date-fns/locale';
import { useNotification } from '../../contexts/NotificationProvider';
import useNotificationStorageService from '../services/NotificationStorageService';
import { ALLUSERS_PER_PAGE, ALLSHIFTS_PER_PAGE, SHIFTS_PER_PAGE, USERS_PER_PAGE } from '../../config';
import TopicNotificationService from '../services/TopicService';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Toast, ToastContainer } from 'react-bootstrap';
import useDateService from '../services/DateService';
// import { FaCalendarCheck } from "react-icons/fa6";
// import { FaCircleQuestion } from "react-icons/fa6";

function decodeJWT(token: string) {
  if (!token) return null; // Vérifie si le token est null ou undefined

  try {
      const base64Url = token.split('.')[1];
      if (!base64Url) throw new Error("JWT invalide, impossible d'extraire le payload.");

      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const decoded = atob(base64);

      const jsonPayload = decodeURIComponent(
          decoded
              .split('')
              .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
              .join('')
      );

      // console.log("Payload final avant JSON.parse :", jsonPayload);

      return JSON.parse(jsonPayload);
  } catch (e) {
      console.error("Erreur lors du décodage du JWT :", e);
      return null;
  }
}

const PREFIX = 'Schedulum-form';
// #FOLD_BLOCK
const classes = {
  addButton: `${PREFIX}-addButton`,
};
const StyledFab = styled(Fab)(({ theme }) => ({
  [`&.${classes.addButton}`]: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(4),
    transition: 'bottom 0.3s ease-in-out'
  },
}));

let priorities: any[] = [{ id: '', text: '', color: green },];

const grouping = [{
  resourceName: 'priorityId',
}];

const filterTasks = (items: any[], priorityId: string | number) => items.filter(task => (
  !priorityId || task.priorityId === priorityId
));

function utcWithoutAdjustment(dateString: string) {
  const localDate = new Date(dateString);
  const utcDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
  return utcDate.toISOString().slice(0, 19) + ".000Z";
}

type Task = {
  title: string;
  info: string;
  role: string;
  priorityId: string;
  startDate: string;
  endDate: string;
  user?: string;
  location?: string;
  confirmed?: boolean;
  suspended?: boolean;
  accepted?: boolean;
  id?: string; // number
};

// type SchedulerState = {
//   currentDate: string;
//   currentViewName: string;
//   data: Task[];
//   currentPriority: string | number;
//   resources: any[];
// };

// const returnDates = (date: any) => {
//   const theDate = new Date(new Date(date).getTime() - ((TIMEZONE*60)*60000)); //new Date();
//   const setYesterday = theDate.setDate(theDate.getDate() - 2); // IMPORTANT TO GET shift on different days
//   const yesterday = new Date(setYesterday).toISOString().split('T')[0] + "T05:00:00.000Z"; // +5 fuseau horraire
//   const setTomorrow = theDate.setDate(theDate.getDate() + 4); // IMPORTANT TO GET shift on different days
//   const tomorrow = new Date(setTomorrow).toISOString().split('T')[0] + "T05:00:00.000Z"; // +5 fuseau horraire

//   return [yesterday, tomorrow];
// };

// hack for priority FIX SOON:
const firstPriority = [];

const SchedulerMobileView = () => {
  // I18N
  const { t } = useTranslation();
  // JWT TOKEN
  const token = new URLSearchParams(window.location.search).get("token");
  const locale = new URLSearchParams(window.location.search).get("language");
  // PAGINATION
  const [pageTokens, setPageTokens] = useState([null]);
  const [totalPagination, setTotalPagination] = useState(1);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [dontUpdateAnymore, setDontUpdateAnymore] = useState(false);
  const [usersState, setUsersState] = useState([]);
  const [gotAllTokens, setGotAllTokens] = useState(false);
  // DATE SERVICES
  const {getTIMEZONE, getDateTimeWithTimezone } = useDateService();
  const TIMEZONE = getTIMEZONE();
  // NAVIGATION
  const location = useLocation();
  const navigate = useNavigate();
  // TOAST
  const [showToast, setShowToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // NOTIFICATION
  const {sendTopicNotification} = TopicNotificationService();
  const notificationContext = useNotification();
  const notificationCount = notificationContext?.notificationCount;
  const setNotificationCount = notificationContext?.setNotificationCount;
  const {updateNotificationModelCount} = useNotificationStorageService();
  const shiftCount = notificationContext?.shiftCount;
  const setShiftCount = notificationContext?.setShiftCount;
  const confirmShiftCount = notificationContext?.confirmShiftCount;
  const setConfirmShiftCount = notificationContext?.setConfirmShiftCount;
  // WORKERS FOR SELECT LIST
  const [workers, setWorkers] = useState([]);
  const [users, setUsers] = useState([]);
  // const [shifts, setShifts] = useState([]);
  // DRAG & DROP
  // const [allowDrag, setAllowDrag] = useState(false);
  
  const { DayViewTimeTableCell, DayViewDayScaleCell, WeekViewTimeTableCell, 
    WeekViewDayScaleCell, AllDayCell, GroupingPanelCell, FlexibleSpace, TooltipContent, TooltipHeader, AppointmentFormContainerBasic } = useScheduleItems(priorities);
  const [language, setLanguage] = useState('en');
  // const [schedulerKey, setSchedulerKey] = useState(0);
  const formTargetRef = useRef<HTMLElement | null>(null);
  // const flexibleSpaceRef = useRef<any>(null);
  const [form, setForm] = useState({
    creatingForm: false,
    data: [],
    currentDate: '',
    confirmationVisible: false,
    editingFormVisible: false,
    deletedAppointmentId: undefined,
    editingAppointment: undefined,
    previousAppointment: undefined,
    addedAppointment: {},
    startDayHour: 0,
    endDayHour: 24,
    isNewAppointment: false,
    selectOptions: [],
    isMulti: false,
    removeConfirm: false,
    removePublic: true,
  });
  
  // const [toolTip, setToolTip] = useState({
  //   visible: false,
  // });

  const [state, setState] = useState({
  // this.state = {
    currentDate: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0], //new Date().toISOString().split("T")[0],
    currentViewName: "Day",
    data: [] as Task[],
    currentPriority: 0 as number | string, //number 0 only to fix the default priotity for all the shifts
    resources: [
      {
        fieldName: "priorityId",
        title: "Priority",
        instances: priorities,
      },
    ],
  });

  const refreshList = (items: any) => {
    const newTasks = items.map((shift: any) => ({
      title: shift.info,
      info: shift.info,
      role: shift.role,
      user: shift.user,
      userId: shift.userId,
      username: shift.username,
      location: shift.location,
      confirmed: shift.confirmed,
      suspended: shift.suspended,
      accepted: shift.accepted,
      priorityId: shift.userId,
      startDate: shift.startAt.split('.')[0],
      endDate: shift.stopAt.split('.')[0],
      id: shift.shiftId,
    })).flat();

    setState((prevState) => ({...prevState, data: newTasks }));
    setForm((prevForm) => ({...prevForm, data: newTasks }));
    // console.log('STATE',state);
    // flexibleSpace.update();

    return newTasks;
  };

  const [fetchDataUser, {data: dataUser, loading, error, refetch, fetchMore}] = useLazyQuery//useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser)//,
      // {variables: {userId: AuthUserId}});

  // const [fetchDataUsersCount, {data: dataUsersCount, loading: loadingUsersCount, error: errorUsersCount, 
  //     refetch: refetchUsersCount, fetchMore: fetchMoreUsersCount}] = useLazyQuery
  //     <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);
      
  const [fetchDataUsers, {data: dataUsers, loading: loadingUsers, error: errorUsers, 
      refetch: refetchUsers, fetchMore: fetchMoreUsers}] = useLazyQuery
      <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);

  // Select list in forms (update & create)
  const [fetchDataWorkers, {data: dataWorkers, loading: loadingWorkers, error: errorWorkers, 
      refetch: refetchWorkers, fetchMore: fetchMoreWorkers}] = useLazyQuery
      <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);

  // Fetch pagination
  const [fetchDataPages, {data: dataPages, loading: loadingPages, error: errorPages, 
      refetch: refetchPages, fetchMore: fetchMorePages}] = useLazyQuery
      <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);
  
  // const getTheDate = returnDates(new Date());
  // const yesterday = getTheDate[0];
  // const tomorrow = getTheDate[1];
  // console.log('yrst',yesterday);
  // console.log('tomorro', tomorrow);

  const [fetchData, {data: dataShift, loading: loadingShift, error: errorShift, 
    refetch: refetchShift, fetchMore: fetchMoreShift}] = useLazyQuery
    <ShiftsByComIdQuery, ShiftsByComIdQueryVariables>(shiftsByComId);

  const [doUpdateShift, {data: dataShiftAppUpdate, loading: loadingShiftAppUpdate, 
    error: eorrorShiftAppUpdate}] = useMutation
    <UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables>(updateAgendaShift);

  const [doCreateShift, {data: dataShiftCreate, loading: loadingShiftCreate, 
    error: eorrorShiftCreate}] = useMutation
    <CreateAgendaShiftByUserIdMutation, CreateAgendaShiftByUserIdMutationVariables>(createAgendaShiftByUserId);

  // let AuthUserId = "24284418-0021-70d2-3fb3-de654dc17cb9";
  const [AuthUserId, setAuthUserId] = useState("");

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastStatus(location.state.status);
      setToastTitle(location.state.title);
      setToastMessage(location.state.toastMessage);
      setShowToast(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const jwt = urlParams.get("token");
    const payload = decodeJWT(jwt);
    if (payload) {
      setAuthUserId(payload.sub);
    };
    // const tokenJSON = Cookies.get('authToken');
    // if (tokenJSON) {
    //   // alert(tokenJSON);
    //   const token = JSON.parse(tokenJSON);
    //   // alert(token.payload.sub);
    //   setAuthUserId(token.payload.sub);
    // };

    // Clean Notification
    setNotificationCount((notificationCount ?? 0) - (shiftCount ?? 0));
    setNotificationCount((notificationCount ?? 0) - (confirmShiftCount ?? 0));
    updateNotificationModelCount('shift', 0);
    updateNotificationModelCount('confirmShift', 0);
    setShiftCount(0);
    setConfirmShiftCount(0);
  }, []);

  useEffect(() => {
    if (AuthUserId != "") {
      fetchDataUser({variables: {userId: AuthUserId}});
    };
  }, [AuthUserId]);


  useEffect(() => {
    // const savedLang = Cookies.get('language');
    if (locale !== language) {
      console.log('LANG', locale);
      i18n.changeLanguage(locale);
      setLanguage(locale);
    }
  }, [i18n, t, locale]);

  const priorityChange = (value: string) => {
    const { resources } = state;
    const filteredPriorities = priorities.filter((p) => p.id === value);
    // const val = parseInt(value);
    // let worker = [];
    // if (priorities[1]) {
    //   priorities.map((p) => {
    //     if (p.id === value) {
    //       worker = [p];
    //     }
    //   })
    // } else {
    //   worker = priorities[0];
    // }
    // console.log('value1', priorities);
    const nextResources = [
      {
        ...resources[0],
        // instances: val > 0 ? [priorities[val - 1]] : priorities,
        instances: value != '0' ? filteredPriorities : priorities,
        // instances: value != '0' ? [worker] : priorities,
      },
    ];
    setState((prevState) => ({...prevState, currentPriority: value, resources: nextResources }));
    // flexibleSpace.update();
  };

  // const FlexibleSpaceWithIcons = (props: any) => {
  //   return (
  //     <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px' }}>
  //       <FaCalendarCheck size={40} color="white" style={{
  //         backgroundColor: 'rgb(17, 135, 150)',
  //         borderRadius: 80, padding: '10px'
  //       }} />
  //       <FaCircleQuestion size={40} color="white" style={{
  //         backgroundColor: 'rgb(129, 135, 240)',
  //         borderRadius: 80, padding: '10px'
  //       }} />
  //       <FlexibleSpace {...props} /> {/* Garder le reste de la Toolbar */}
  //     </div>
  //   );
  // };

  const flexibleSpace = connectProps(FlexibleSpace, () => { // FlexibleSpaceWithIcons, 
  // const flexibleSpace = connectProps(FlexibleSpaceWithIcons, () => { 

    // const { currentPriority } = state;
    
    return {
        priority: state.currentPriority,
        priorityChange: priorityChange,
    };
  });

  // const componentDidUpdate = () => {
  //   flexibleSpace.update(); // #IMPORTANT_LINE
  // };

  const user = dataUser?.getAgendaUser;

  const getUsers = async (token: string) => { //date: Date, 
    if (user?.comId) {
      return await fetchDataUsers({
        variables: {
          comId: user?.comId,  
          limit: USERS_PER_PAGE,               
          nextToken: token,  
          sortDirection: ModelSortDirection.ASC,
          filter: {
            suspended: {eq : false},
          }
        },
      });
    }
  }

  // Select Form list = Workers
  const getWorkers = async () => {  
    if (user?.comId) {
      return await fetchDataWorkers({
        variables: {
          comId: user?.comId,  
          limit: ALLUSERS_PER_PAGE,
          sortDirection: ModelSortDirection.ASC,
          filter: {
            suspended: {eq : false},
          }
        },
      });
    }
  }

  // For pagination
  const getPages = async (token: string) => {  
    if (user?.comId) {
      return await fetchDataPages({
        variables: {
          comId: user?.comId,  
          limit: USERS_PER_PAGE,               
          nextToken: token,  
          sortDirection: ModelSortDirection.ASC,
          filter: {
            suspended: {eq : false},
          }
        },
      });
    }
  }
  
  useEffect(() => {
    if (dataUser && !loading) {
      getUsers(pageTokens[pageTokens.length - 1]);
      getWorkers();
      // console.log("USERS ->", users);
    }
  }, [dataUser, loading]); //, fetchDataUsers, pageTokens]);

  useEffect(() => {
    if (dataWorkers && dataWorkers.usersByComId) setWorkers(dataWorkers?.usersByComId?.items);
  }, [dataWorkers]);

  // useEffect(() => {
  //   if (workers.length > 0) setUsers(workers);
  // }, [workers]);

  useEffect(() => {
    if (dataUsers && dataUsers.usersByComId && !dontUpdateAnymore) {
      const newUsers = dataUsers.usersByComId.items;
      const newToken = dataUsers.usersByComId.nextToken;
 
      setUsersState(newUsers); // Met à jour la liste des utilisateurs
      if (newToken) {
        setPageTokens((prevTokens) => [...prevTokens, newToken]); // Ajoute un nouveau token
        setHasMorePages(true);
      } else {
        setHasMorePages(false); // Pas de token suivant, fin de la pagination
      }
    }
  }, [dataUsers]);

  useEffect(() => {
    if (hasMorePages) {
      setTotalPagination(pageTokens.length);
    } else {
      setTotalPagination(pageTokens.length - 1);
    }
  },[hasMorePages]);

  const handlePageChange = async (pageIndex: any) => {
    setDontUpdateAnymore(true);
    setCurrentPageIndex(pageIndex);

    const selectedToken = pageTokens[pageIndex - 1]; // Récupérer le token de la page sélectionnée
    if (selectedToken !== undefined) {
      const { data: { usersByComId: { items: newUsers, nextToken: newNextToken } } } = await getUsers(selectedToken);

      if (newUsers.length !== 0) {
        setUsersState(newUsers);
        USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
        if (newNextToken && !pageTokens.includes(newNextToken)) {
          setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
        }
        // console.log(pageTokens);
      } else {
        if (hasMorePages) {
          setHasMorePages(false);
        }
      }
    }
  };

  const handleNextPage = async () => {
    setDontUpdateAnymore(true);
    // if (hasMorePages) {
      // const nextToken = pageTokens[pageTokens.length - 1]; // Dernier token actuel
      const nextToken = pageTokens[currentPageIndex];

      if (nextToken) {
        const { data: { usersByComId: { items: newUsers, nextToken: newNextToken } } } = await getUsers(nextToken);

        if (newNextToken) {
          setUsersState(newUsers);
          USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
          // console.log('allo');
          if (!pageTokens.includes(newNextToken)) {
              setPageTokens((prevTokens) => [...prevTokens, newNextToken]); // Ajoute le nouveau token
          }
          setCurrentPageIndex(currentPageIndex + 1);
        } else {
          if (newUsers.length > 0) {
            setUsersState(newUsers);
            USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
            setCurrentPageIndex(currentPageIndex + 1);
            // removeLastPagination();
            setHasMorePages(false);
          } else {
            if (hasMorePages) {
              // removeLastPagination();
              setHasMorePages(false);
            }
          }
          // setHasMorePages(false); // Si pas de nextToken, on désactive la pagination
        }
        // console.log(pageTokens);

        // setCurrentPageIndex(currentPageIndex + 1); // Mise à jour de l'index de la page
      } else {
        console.error("Next token is undefined or null");
      }
    // }
  };

  const handlePreviousPage = async () => {
    if (currentPageIndex > 1) {
      const prevToken = pageTokens[currentPageIndex - 2];
      const { data: { usersByComId: { items: prevUsers, nextToken: newNextToken } } } = await getUsers(prevToken);

      setUsersState(prevUsers);
      // setPageTokens(pageTokens.slice(0, -1)); 
      // if (hasMorePages) {
      //  setHasMorePages(nextToken ? true : false);
      // }
      USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };

  const fetchAllTokens = async () => {
    let allTokens = [];
    let nextToken = null;

    do {
      const response = await getPages(nextToken);
      const newNextToken: string | null | undefined = response?.data?.usersByComId?.nextToken;
      if (newNextToken) {
          allTokens.push(newNextToken);
      }
      nextToken = newNextToken;
    } while (nextToken);

    setPageTokens((prevTokens) => [...prevTokens, ...allTokens.filter(t => !prevTokens.some(p => p === t))]);
    setTotalPagination(allTokens.length + 1); 
    setGotAllTokens(true);
  };

  useEffect(() => {
    if (users.length > 0) {
      fetchAllTokens();
    }
  }, [users]);

  // const users = usersState;//dataUsers?.usersByComId?.items;
  // const usersCount = dataUsersCount?.usersByComId?.items;
  // WORK WELL BUT SLOW FOR FORMS (UPDATE & CREATE) WE SHOULD USE A BUTTON TO LOAD EVERYTHING [STILL GOOD LIKE WHAT WE HAVE NOW]
  // GROUPING EMPLOYEES BY GROUPE OF PEOPLES and ordering them with it should be better ...
  // OR ADD A SPINNER WHEN WE CALL A FORM ?? ... DRAG AND DROP UPDATE ARE VERY SLOW TOO
  // useEffect(() => {
  //   if (usersState.length > 0 && workers.length === 0) setUsers(usersState);
  //   setTimeout(() => {
  //     if (users.length > 0 && workers.length > 0) setUsers(workers);
  //   }, 3000);
  // }, [usersState, workers]); //, workers]);
  // THIS ONE RUN GREAT (PAGINATION)
  useEffect(() => {
    if (usersState.length > 0) setUsers(usersState);
  }, [usersState]); //, workers]);

  useEffect(() => {
    // priorityChange(0);
    if (users) {
      // priorities = []; // dont work
      // priorities.length = 0; // dont work
      // console.log('PRIO', priorities);
      priorities.splice(0, priorities.length);
      users.forEach(user => {
        priorities.push({ id: user.userId, text: user.username, color: green })
      });

      setState(prevState => ({
        ...prevState,
        currentPriority: 0, // ou la priorité par défaut
        resources: [{
          fieldName: "priorityId",
          title: "Priority",
          instances: priorities,
        }],
      }));
    }
  }, [users]);

  useEffect(() => {
    // console.log('shift6', state.currentPriority);
    if (!user) return;
    if (users.length === 0) return;
      const usr = dataUser?.getAgendaUser;
      const theDate = new Date(state.currentDate);
      const sDate = theDate.setDate(theDate.getDate() - (state.currentViewName == "Day" ? 2 : 7));
      // const startDate = new Date(sDate).toISOString().split('T')[0] + "T05:00:00.000Z";
      const startDate = new Date(getDateTimeWithTimezone(new Date(sDate).toISOString(), TIMEZONE*-1)).toISOString();

      const eDate = theDate.setDate(theDate.getDate() + (state.currentViewName == "Day" ? 5 : 14));
      // const endDate = new Date(eDate).toISOString().split('T')[0] + "T05:00:00.000Z";
      const endDate = new Date(getDateTimeWithTimezone(new Date(eDate).toISOString(), TIMEZONE*-1)).toISOString();
      
      const userFilters = users.map(user => ({ userId: { eq: user.userId } }));
      if (usr?.comId) {
        // console.log('shift5', state.currentPriority);
        // console.log('shift999', startDate + " " + endDate);
        if (state.currentPriority === 0) {
          if (workers.length > 0 && users.length === workers.length) {
            // USELESS WITHOUT WORKERS BUT TOO SLOW !!!!
            fetchData({variables: {
              comId: usr?.comId, 
              limit: ALLSHIFTS_PER_PAGE,
              startAt: {gt: startDate},//state.currentDate},
              filter: {
                stopAt: {lt: endDate},
                // confirmed: {eq: true},
                suspended: {eq : false},
                deleted: {ne: true},
              }
            }});
          } else {
            fetchData({variables: {
              comId: usr?.comId, 
              limit: ALLSHIFTS_PER_PAGE,
              startAt: {gt: startDate},//state.currentDate},
              filter: {
                or: userFilters,
                stopAt: {lt: endDate},
                // confirmed: {eq: true},
                suspended: {eq : false},
                deleted: {ne: true},
              }
            }});
          }
        } else {
          // console.log('shift5555555', state.currentPriority);
          fetchData({variables: {
            comId: usr?.comId,
            limit: SHIFTS_PER_PAGE,
            startAt: {gt: startDate},//state.currentDate},
            filter: { 
              userId: {eq: state.currentPriority.toString()},
              stopAt: {lt: endDate},
              // confirmed: {eq: true},
              suspended: {eq : false},
              deleted: {ne: true}
              }
          }});
        }
      }
  }, [users, usersState, dataUsers, loading, fetchData, state.currentDate, state.currentViewName, state.currentPriority]); //dataUsers
  // , workers // Add to get all shifts but too slow
  let shifts = dataShift?.shiftsByComId?.items;
  // console.log('shift2', shifts);
  // console.log('shift3', form.data);
  // console.log('shift4', state.currentPriority);

  useEffect(() => {
    if (shifts && !loadingShift) {
      refreshList(shifts);
    }
  }, [loadingShift, shifts]);//, state.currentDate, state.currentViewName]);
  
  useEffect(() => {
    // alert('lol');
    flexibleSpace.update();
    
  }, [state]);

  // hack pour aria-hidden
  useEffect(() => {
    const rootDiv = document.getElementById("root");
    if (rootDiv) {
      rootDiv.removeAttribute("aria-hidden");
      // rootDiv.setAttribute("inert", "true"); // ✅ Ajoute inert au lieu d’aria-hidden
    }
    document.title = t('title.scheduler');
  }, []);

  if (!shifts || !state?.resources[0]?.instances[0]?.text) { // solve the loading (GROUPING) problem  // || state.data.length === 0
    // console.log(shifts);
    // if (loading || loadingUsers || loadingShift) {
    // if (loading || loadingUsers || loadingShift || !users || !shifts) { // need to keep it like that to load all before the loading stop
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };
  // if (error || !user) {
  //   return console.log({
  //     key: `error_${user?.userId}`, 
  //     title: "Error fetching the user", 
  //     message: error?.message || "User not found",
  //     // onRetry: () => refetch()
  //   });
  // };
  const truncate = (str: string | undefined, maxlength: number) => {
    if (str) {
      return (str.length > maxlength) ?
      str.slice(0, maxlength - 1) + '…' : str;
    } else {
      return str;
    }
  };

  const currentViewNameChange = (currentViewName: string) => {
    setState((prevState) => ({...prevState, currentViewName }));
  };

  const currentDateChange = (currentDate: Date) => {
    const formattedDate = currentDate.toISOString().split('T')[0]; // Convert Date to YYYY-MM-DD
    setState((prevState) => ({...prevState, currentDate: formattedDate }));
  };

  const Appointment = ({
    children, style, ...restProps
  }: any) => (
    <Appointments.Appointment
      {...restProps}
      style={{ 
        ...style,
        backgroundColor: restProps.data.confirmed ? '#118796' : '#8187f0', //'#FFC107',
        borderRadius: '8px',
      }}
      // style={allowDrag(restProps.data) ? { 
      //   ...style,
      //   backgroundColor: restProps.data.confirmed ? '#118796' : '#8187f0', //'#FFC107',
      //   borderRadius: '8px',
      // }
      // : {backgroundColor: "#666", cursor: 'not-allowed'}}
      draggable={allowDrag(restProps.data) ? true : false}
      isShaded
      // appointmentType={'vertical'}//{'horizontal'}
    >
      {/* {children} */}
      <div style={{ padding: '8px', color: 'white'}}>
        {/* Afficher le titre du rendez-vous */}
        <strong>{restProps.data.role || 'Rendez-vous sans titre'}</strong>
        
        {/* Afficher la description du rendez-vous */}
        {restProps.data.location && <p><em>Lieu: {restProps.data.location}</em></p>}

        {/* Afficher l'heure de début et l'heure de fin */}
        {restProps.data.startDate && restProps.data.endDate && (
          <p>{`${format(new Date(restProps.data.startDate), "H:mm")} - ${format(new Date(restProps.data.endDate), "H:mm")}`}</p>
        )}

        {/* Afficher d'autres détails */}
        {/* {children} */}
      </div>
      {/* title: shift.info,
      role: shift.role,
      user: shift.user,
      location: shift.location,
      confirmed: shift.confirmed,
      suspended: shift.suspended,
      accepted: shift.accepted,
      priorityId: shift.userId,
      startDate: shift.startAt,
      endDate: shift.stopAt,
      id: shift.shiftId, */}
    </Appointments.Appointment>
  );

  // AppointmentForm & it's functions
  const onEditingAppointmentChange = (editingAppointment: any) => {
    setForm((prevState) => ({...prevState, 
      editingAppointment: editingAppointment
    }));
  }

  const onAddedAppointmentChange = (addedAppointment: any) => {
    setForm((prevState) => ({...prevState, addedAppointment }));
    if (form.editingAppointment !== undefined) {
      setForm((prevState) => ({...prevState, previousAppointment: form.editingAppointment }));
    }
    setForm((prevState) => ({...prevState, editingAppointment: undefined, isNewAppointment: true }));
  }

  const commitChanges = ({ added, changed, deleted }: any) => {
    // console.log("Commit Changes Triggered:", { added, changed, deleted });
    // dragAndDropChanges({ added, changed, deleted });
    // setForm((state) => {
    //   let { data } = state;
    //   if (added) {
    //     const startingAddedId = data.length > 0 ? data[data.length - 1].id + 1 : 0;
    //     data = [...data, { id: startingAddedId, ...added }];
    //   }
    //   if (changed) {
    //     data = data.map(appointment => (
    //       changed[appointment.id] ? { ...appointment, ...changed[appointment.id] } : appointment));
    //   }
    //   if (deleted !== undefined) {
    //     setDeletedAppointmentId(deleted);
    //     toggleConfirmationVisible();
    //   }
    //   return { data, addedAppointment: {} };
    // });
  }
  const dragAndDropChanges = ({ added, changed, deleted }: any) => {
    // console.log("Drag and Drop Changes:", { added, changed, deleted });
    setState((prevState) => {
      let { data } = prevState;
    
      if (added) {
        // Générer un nouvel ID unique sous forme de string
        const newId = generateCustomId(); //`-${data.length + 1}`;
        data = [...data, { id: newId, ...added }];
      }
    
      if (changed) {
        data = data.map(appointment =>
          changed[appointment.id] ? { ...appointment, ...changed[appointment.id] } : appointment
        );
        const id = Object.keys(changed)[0];
        const worker = users.filter((user) => changed[id].priorityId === user.userId);
        // verifyUpdate(changed, shift);
        verifyUpdate(changed, worker);
      }
    
      if (deleted !== undefined) {
        data = data.filter(appointment => appointment.id !== deleted);
      }
    
      return { ...prevState, data };
    });
  }

  const toggleEditingFormVisibility = () => {
    // const { editingFormVisible } = this.state;
    setForm((prevForm) => ({...prevForm, editingFormVisible: !form.editingFormVisible}));
  }

  const toggleConfirmationVisible = () => {
    setForm((prevState) => ({...prevState, confirmationVisible: !form.confirmationVisible }));
  }

  const commitDeletedAppointment = () => {
    const nextData = form.data.filter(appointment => appointment.id !== form.deletedAppointmentId);
    // setForm((prevState) => ({...prevState,
    //   const nextData = form.data.filter(appointment => appointment.id !== form.deletedAppointmentId);

    //   return { data: nextData, deletedAppointmentId: null };
    // });
    return { data: nextData, deletedAppointmentId: undefined as string | undefined };
    toggleConfirmationVisible();
  }

  const deleteShift = async (appointment: any) => {
    try {
      await doUpdateShift({variables: {input: {
        shiftId: appointment.id,
        suspended: true,
        deleted: true,
      }}});
      setToastStatus("bg-danger");
      setToastTitle('');
      setToastMessage(t('toast.shiftDeleted'));
      setShowToast(true);
      
      setShowCustomModal(false);
      refetchShift();
    } catch (error) {
      console.log('error', (error as Error).message);
    }    
  };

  const verifyDeleteShift = (app: any, tooltip: boolean = false) => {
    if (tooltip) {
      removeToolTip();
    }
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.deleteTitle')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{t('shift.deleteMessage')}</p></Modal.Body>
          <Modal.Footer>
            <Btn variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Btn>
            <Btn variant="primary" onClick={ () => deleteShift(app)}>
              {t('shift.delete')}
            </Btn>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };

  const updatingShift = async (event: any) => {
    if (event.deleted) {
      const app = {id: event.deleted}
      verifyDeleteShift(app);
      return
    }
    // console.log('EVENT', event);
    // return
    const id = Object.keys(event.changed)[0];
    // console.log("ID", id);
    if (id) { 
      try {
        const userId = event.changed[id].users ? event.changed[id].users[0].id : event.changed[id].userId;
        // console.log('USR', userId);
        const info = event.changed[id].info;
        const role = event.changed[id].role;
        const location = event.changed[id].location;
        const confirmed = event.changed[id].confirmed;
        // const userId = event.changed[id].priorityId;
        const startDate = utcWithoutAdjustment(new Date((event.changed[id].startDate)).toString()); //.toISOString().slice(0, 19) + ".000Z";
        const endDate = utcWithoutAdjustment(new Date((event.changed[id].endDate)).toString()); //.toISOString().slice(0, 19) + ".000Z";

        const confirmedDate = startDate.split("T")[0]+"12:00:00.000Z";

        // console.log('SD',new Date((event.changed[id].startDate.toString())));
        // console.log('SD',startDate);
        // console.log('ED',endDate);
        await doUpdateShift({variables: {input: {
          shiftId: id,
          userId: userId,
          role: truncate(role, 150),
          info: truncate(info, 150),
          location: truncate(location, 150),
          confirmed,
          startAt: startDate,
          stopAt: endDate,
        }}});
        if (userId !== AuthUserId) {
          if (confirmed) {
            sendTopicNotification(role ?? undefined, location ?? undefined, user.FCMtoken ?? undefined, userId ?? undefined, id ?? undefined, startDate, endDate, "confirmShift");
          } else {
            sendTopicNotification(role ?? undefined, location ?? undefined, user.FCMtoken ?? undefined, userId ?? undefined, id ?? undefined, startDate, endDate, "shift");
          }
        }
        setToastStatus("bg-success");
        setToastTitle('');
        setToastMessage(t('toast.shiftUpdated'));
        setShowToast(true);
        // alert(location);
        refetchShift();
      } catch (error) {
        console.log('error', (error as Error).message);
      }    
    } else {
      alert('Shift update failed');
    }
  }

  const updatingDragAndDRapShift = async (event: any, username: string) => {
    const id = Object.keys(event)[0];
    if (id) { 
      try {
        const userId = event[id].priorityId;
        const startDate = utcWithoutAdjustment(new Date((event[id].startDate)).toString()); 
        const endDate = utcWithoutAdjustment(new Date((event[id].endDate)).toString());
        await doUpdateShift({variables: {input: {
          shiftId: id,
          userId: userId,
          username: username,
          startAt: startDate,
          stopAt: endDate,
        }}});
        setShowCustomModal(false);
        refetchShift();
      } catch (error) {
        console.log('error', (error as Error).message);
      }    
    } else {
      alert('Shift update failed');
    }
  }

  const getLanguage = () => {
      switch (language) {
        case 'en':
          return enUS
        case 'fr':
          return fr
        default:
          return enUS
      }
    }

  const verifyUpdate = (data: any, worker: any[]) => {
    const id = Object.keys(data)[0];
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.dragUpdateTitle')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <h5>{t('shift.worker')}{worker[0].username}</h5>
            <p>{t('shift.dragUpdateStartAt')}{format(new Date(data[id].startDate), "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
            <p>{t('shift.dragUpdateStopAt')}{format(new Date(data[id].endDate), "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
          </Modal.Body>
          <Modal.Footer>
            <Btn variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Btn>
            <Btn variant="primary" onClick={ () => updatingDragAndDRapShift(data, worker[0].username)}>
              {t('shift.update')}
            </Btn>
          </Modal.Footer>
      </>);
      setShowCustomModal(true);
  }

  const generateCustomId = () => {
    const prefix = "Shift"; // "ShiftApp";
    const uniquePart = uuidv4();
    return `${prefix}-${uniquePart}`;
  };

  const shiftCreation = async (id: any, data: any, usr: any) => {
    try{
      const startAt = utcWithoutAdjustment(new Date(data.startDate).toString());
      const stopAt = utcWithoutAdjustment(new Date(data.endDate).toString());
      await doCreateShift({variables: {
        shiftId: id,
        shiftAppId: "BLANK",
        userId: usr.id,
        comId: user.comId,
        role: truncate(data.role, 150),
        info: truncate(data.info, 150),
        location: truncate(data.location, 150),
        username: usr.username,
        lat: data.lat,
        lng: data.lng,
        startAt,
        stopAt,
        quality: "0",
        performance: "0",
        punctuality: "0",
        rate: "0",
        deleted: false,
        accepted: false,
        suspended: false, // data.suspended,
        confirmed: data.confirmed,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      }});
      setToastStatus("bg-success");
      setToastTitle('');
      setToastMessage(t('toast.shiftCreated'));
      setShowToast(true);

      if (usr.id !== AuthUserId) {
        if (data.confirmed) {
          sendTopicNotification(data.role ?? undefined, data.location ?? undefined, user.FCMtoken ?? undefined, usr.id ?? undefined, id ?? undefined, startAt, stopAt, "confirmShift");
        } else {
          sendTopicNotification(data.role ?? undefined, data.location ?? undefined, user.FCMtoken ?? undefined, usr.id ?? undefined, id ?? undefined, startAt, stopAt, "shift");
        }
      }
      refetchShift();
    } catch (error) {
      console.log('error', (error as Error).message);
    } 
  }

  const creatingShift = (event: any) => {

    event.added.users.forEach((usr: any) => {
      const shiftId = generateCustomId();
      shiftCreation(shiftId, event.added, usr);
    });
  }

  const usersOptions = 
  // [
  //   {
  //     id: 1,
  //     name: 'Leanne Graham'
  //   },
  //   {
  //     id: 2,
  //     name: 'Ervin Howell'
  //   }
  // ];

  // users ? 
  //   users.map((usr: AgendaUser) => ({
  //     id: usr.userId,
  //     username: usr.username
  //   }))

  workers ?
    workers.map((usr: AgendaUser) => ({
      id: usr.userId,
      username: usr.username
    }))
  : [];

  const appointmentForm = connectProps(AppointmentFormCustom, () => {
    const {
      editingFormVisible,
      editingAppointment,
      data,
      addedAppointment,
      isNewAppointment,
      previousAppointment,
      selectOptions,
      isMulti,
      removeConfirm,
      removePublic,
    } = form;
    // console.log('DATA', data);
    const currentAppointment = data
        .filter(appointment => editingAppointment && appointment.id === editingAppointment.id)[0]
        || addedAppointment;
    const cancelAppointment = () => {
      if (isNewAppointment) {
        setForm((prevState) => ({...prevState, 
          editingAppointment: previousAppointment,
          isNewAppointment: false
        }));
      }
    };

    return {
      visible: editingFormVisible,
      appointmentData: currentAppointment,
      commitChanges: form.creatingForm ? creatingShift : updatingShift,//commitChanges, //() => "", //this.commitChanges,
      visibleChange: toggleEditingFormVisibility, // () => ""
      onEditingAppointmentChange: creatingShift, //() => "", //this.onEditingAppointmentChange,
      cancelAppointment,
      selectOptions: usersOptions,
      isMulti: isMulti,
      removeConfirm: false,
      removePublic: removePublic,
    };
  });

  const openEditingForm = (appointment: any) => {
    setForm((prevState) => ({...prevState,
      editingFormVisible: true,
      editingAppointment: appointment, // Définit l'appointment actif
      creatingForm: false,
      isMulti: false,
    }));
    // setToolTip({ visible: false });
    removeToolTip();
    
  };

  const removeToolTip = () => {
    // setToolTip({ visible: !toolTip.visible });
    const body = document.body.removeAttribute('style');
    const root = document.getElementById('root').removeAttribute('aria-hidden');

    const presentation = document.querySelector('.MuiBackdrop-root');
    (presentation as HTMLElement).click();
  };

  // Composant personnalisé du ViewSwitcher
  const CustomViewSwitcher = ({ onChange, availableViews }: ViewSwitcherBase.SwitcherProps) => {
    // Définition des labels personnalisés
    const customLabels = {
      Day: t('scheduler.day'),
      Week: t('scheduler.week'),
      Month: t('scheduler.month'),
    };
    // console.log('AVAIL', availableViews);
    return (
      <ToggleButtonGroup
        value={state.currentViewName}
        exclusive
        onChange={(_, newView) => newView && onChange(newView)}
        aria-label="Select a view"
      >
        {availableViews.map((view) => (
          <ToggleButton key={view.name} value={view.name}>
            {customLabels[view.name as keyof typeof customLabels] || view.displayName}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  };

  // drag
  // const dragDisableIds = new Set([3, 8, 10, 12]);
  // const allowDrag = (id: any) => !dragDisableIds.has(id);
  
  // const { data, currentDate, currentViewName, currentPriority, resources} = state;
  // const DraftAppointment = ({ data, ...restProps }: any) => (
  //   <Appointments.Appointment
  //     {...restProps}
  //     style={{
  //       backgroundColor: 'rgba(0, 123, 255, 0.7)',
  //       border: '2px dashed white',
  //     }}
  //   />
  // );

  // const SourceAppointment = ({ data, ...restProps }: any) => (
  //   <Appointments.Appointment
  //     {...restProps}
  //     style={{
  //       opacity: 0.5,
  //       backgroundColor: '#ffc107',
  //     }}
  //   />
  // );

  // const ResizeHandle = (props: any) => (
  //   <div
  //     {...props}
  //     style={{
  //       width: '10px',
  //       height: '100%',
  //       backgroundColor: 'maroon',
  //       cursor: 'ns-resize', //'ew-resize',
  //       position: 'absolute',
  //       right: 0,
  //       top: 0,
  //     }}
  //   />
  // );

  // const allowDrag = ({ id }) => !dragDisableIds.has(id);
  const allowDrag = (appointmentData: any) => {
    // console.log('LOL',appointmentData);
    // Exemple : empêcher le drag pour les événements passés
    return new Date(appointmentData.startDate) > new Date();
  };

  // const allowResize = (appointmentData: any) => {
  //   // console.log('LOL',appointmentData);
  //   // Exemple : empêcher le drag pour les événements passés
  //   return new Date(appointmentData.startDate) > new Date();
  // };

  // const CustomContainer = ({ children, ...restProps }: any) => {
  //   console.log('LOL',children);
  //   // Exclure des props non valides pour le DOM
  //   const { appointmentType, ...validProps } = restProps;
  
  //   return <div {...validProps}>{children}</div>;
  // };

  // Fonction pour empêcher l'élément de dépasser les 200px du bas
  const adjustPosition = () => {
    const element = document.querySelector(`.${classes.addButton}`) as HTMLElement;
    const windowHeight = window.innerHeight; // Hauteur de la fenêtre
    const scrollHeight = document.documentElement.scrollHeight; // Hauteur totale de la page
    const elementHeight = element.offsetHeight; // Hauteur de l'élément

    const bottomLimit = 200; // Distance que l'élément doit respecter du bas
    const maxBottom = scrollHeight - (windowHeight - elementHeight) - bottomLimit;

    // console.log('window', windowHeight);
    // console.log('max', maxBottom);
    // console.log('SCROLL', window.scrollY);
    if (window.scrollY >= maxBottom) {
      // L'élément arrive dans les derniers 200px, le fixer
      // console.log('apres', elementHeight);
      element.style.bottom = `${bottomLimit}px`;
    } else {
      // Remettre la position de base
      // console.log('avant', elementHeight);
      element.style.bottom = '20px';
    }
  }

  // Écouter les événements de défilement pour ajuster la position
  window.addEventListener('scroll', adjustPosition);

  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />

      <ToastContainer className="p-3 toastTop">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide className={`${toastStatus}`}>
          { toastTitle != "" &&
            <Toast.Header className={`text-center ${toastStatus}`}>
              <strong className="mx-auto text-white-50 text-center">{toastTitle}</strong>
            </Toast.Header>
          }
          <Toast.Body className="text-center"><strong className="mx-auto text-white text-center">{toastMessage}</strong></Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="scheduler-container text-center">
        <h2 style={{paddingTop:10, paddingLeft: 0, fontSize: 14}}>{t('home.manageShift')} | <Link to={`/openSchedulerManager?token=${token}&language=${locale}`} style={{textDecoration: 'none'}}>{t('home.manageOpenShift')}</Link></h2>
        {/* <div style={{position: 'relative', backgroundColor: 'blue', width: 80,height: 10}}> */}
        <div style={{
          width:80, 
          backgroundColor: 'transparent',//'red', 
          height: 482,//636//'100vh', 
          top:100,
          position: 'fixed', zIndex:2000}}>
        </div>
      {/* <UserImage user={user} avatarStyle={{width: '100px', height: '100px', borderRadius: '50px'}}/> */}
      <Paper>
        <Scheduler
          data={filterTasks(state.data, state.currentPriority)}
          height={700}
          // key={schedulerKey}
          locale={language}
          firstDayOfWeek={1}
        >
          <ViewState
            currentDate={state.currentDate}
            currentViewName={state.currentViewName}
            onCurrentViewNameChange={currentViewNameChange}
            onCurrentDateChange={currentDateChange}
          />
          <GroupingState
            grouping={grouping}
          />

          <DayView
            startDayHour={0}
            endDayHour={24}
            displayName="Day" // "Jour"
            // name="Day"
            timeTableCellComponent={DayViewTimeTableCell}
            dayScaleCellComponent={DayViewDayScaleCell}
            intervalCount={2}
          />
          <WeekView
            startDayHour={0}
            endDayHour={24}
            excludedDays={[]} // {[0, 6]}
            displayName="Week" // "Semaine"
            // name="Week"
            timeTableCellComponent={WeekViewTimeTableCell}
            dayScaleCellComponent={WeekViewDayScaleCell}
          />
          <AllDayPanel
            cellComponent={AllDayCell}
          />

          <Appointments 
            appointmentComponent={Appointment}
          />
          <Resources
            data={state.resources}
          />
          <IntegratedGrouping />

          <GroupingPanel
            cellComponent={GroupingPanelCell}
          />
          <Toolbar flexibleSpaceComponent={flexibleSpace} />
          {/* <Toolbar flexibleSpaceComponent={flexibleSpaceRef.current} /> */}
          <DateNavigator />

          <ViewSwitcher switcherComponent={CustomViewSwitcher}/>
          <EditingState 
            onCommitChanges={dragAndDropChanges}
          />
          <IntegratedEditing />
          <AppointmentTooltip
            headerComponent={(props) => <TooltipHeader {...props} onOpen={openEditingForm} toggleVisible={removeToolTip} deleteItem={verifyDeleteShift} />}
            contentComponent={TooltipContent}//(props) => <TooltipContent {...props} onOpen={openEditingForm} />}//TooltipContent}
            // visible={toolTip.visible}
            // onVisibilityChange={toggleToolTip}
            // showOpenButton
            // showCloseButton
            // showDeleteButton
          />
          <AppointmentForm
            overlayComponent={appointmentForm}
            // {(props) => (
            //   <AppointmentFormCustom {...props} selectOptions={usersOptions} />
            // )}//{appointmentForm}
            visible={form.editingFormVisible}
            onVisibilityChange={toggleEditingFormVisibility}
            // selectOptions={usersOptions}
            // commitChanges={() => updatingShift}
          />
          <DragDropProvider 
              // allowDrag={allowDrag} 
              // allowResize={allowResize}
              // draftAppointmentComponent={DraftAppointment} 
              // sourceAppointmentComponent={SourceAppointment} 
              // resizeComponent={ResizeHandle} 
              // containerComponent={CustomContainer}          
          />
              
          
        </Scheduler>

        <Dialog
          open={form.confirmationVisible}
          onClose={toggleConfirmationVisible} //cancelDelete}
        >
          <DialogTitle>
            {t('scheduler.deleteShiftTitle')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
            {t('scheduler.deleteShiftMessage')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleConfirmationVisible} color="primary" variant="outlined">
              Cancel
            </Button>
            <Button onClick={commitDeletedAppointment} color="secondary" variant="outlined">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <StyledFab
          color="secondary"
          className={classes.addButton}
          onClick={() => {
            setForm((prevState) => ({...prevState, creatingForm: true, editingFormVisible: true, isMulti: true }));
            onEditingAppointmentChange(undefined);
            onAddedAppointmentChange({
              startDate: new Date(state.currentDate).setHours(form.startDayHour),
              endDate: new Date(state.currentDate).setHours(form.startDayHour + 1),
            });
          }}
        >
          <AddIcon />
        </StyledFab>
      </Paper>
      <div className="pagination-container" style={{ paddingLeft: 5, paddingRight: 5 }}>
        <h2 className="paginationTitle" style={{ paddingTop: 5, paddingBottom: 5 }}>{t('title.users')}</h2>
        <Pagination
          currentPage={currentPageIndex}
          totalPages={totalPagination}//{hasMorePages ? pageTokens.length: pageTokens.length - 1} //{Math.ceil(pageTokens.length / 10)} // Supposons que chaque page ait 10 éléments
          hasMorePages={gotAllTokens ?
              currentPageIndex == totalPagination ?
                false
              :
                hasMorePages
            :
              hasMorePages}
          onNext={handleNextPage}
          // onPrevious={() => setCurrentPageIndex(currentPageIndex - 1)}
          onPrevious={handlePreviousPage}
          onChange={handlePageChange}
          // onChange={(pageIndex) => setCurrentPageIndex(pageIndex)}
          // showFirstLast
        />
      </div>

      {/* Formulaire pour aller à une page spécifique */}
      {/* <div>
        <input
          type="number"
          min={1}
          value={page}
          onChange={(e) => setPage(Number(e.target.value))}
          style={{ marginRight: "10px" }}
        />
        <button onClick={() => goToPage(page)} disabled={loadingUsers}>
          Go to page
        </button>
      </div> */}
    </div>
  </>
  );
};
// }

// const styles = {
//   spinner: {
//     // display: 'flex',
//     /* align-self: center;
//     align-items: center;
//     justify-content: center;
//     margin: 0 auto;
//     margin: 0 auto; */
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//   }
// };

export default SchedulerMobileView;
